import { methods } from '@/utils/methods'

const state = () => ({
  // 詳細情報
  detail: [],
  // 近隣施設
  nearbyList: [],
  // 付近のイベント
  eventList: [],
  // 付近の宿泊施設
  stayList: [],
  // 付近の飲食店
  eatList: [],
  // まとめ相互リンク
  summaries: [],
  // 市区町村ファセット
  cityList: [],
  // トップページ表示情報 - 掲載施設数
  total: 0,
  // トップページ表示情報 - 新着施設
  facilities: [],
  // トップページ表示情報 - 特集
  features: [],
  // トップページ表示情報 - 目的・人気の場所から探す
  facets: [],
  // トップページ表示情報 - お知らせ一覧
  notices: [],
  // トップページまとめリンク
  topSummaries: []
})

const getters = {
  detail: (state) => state.detail,
  nearbyList: (state) => state.nearbyList,
  eventList: (state) => state.eventList,
  stayList: (state) => state.stayList,
  eatList: (state) => state.eatList,
  summaries: (state) => state.summaries,
  cityList: (state) => state.cityList,
  total: (state) => state.total,
  facilities: (state) => state.facilities,
  features: (state) => state.features,
  facets: (state) => state.facets,
  notices: (state) => state.notices,
  topSummaries: (state) => state.topSummaries,
  // トップページ表示情報をまとめて返す
  index: (state) => {
    const facets = []
    if (state.facets) {
      state.facets.forEach((pattern) => {
        let photo = ''
        let id = ''
        if (pattern.facet && Object.keys(pattern.facet).length) {
          if (pattern.facilities[0]) {
            photo = pattern.facilities[0].main_photo || ''
            id = pattern.facilities[0].id || ''
          }

          // メイン画像をセット
          const mainPhoto = methods.getPhotoUrl({
            photo,
            id,
            width: 720,
            height: 540
          })
          // 人気の場所リストをセット
          const list = methods.getAreaOptions(pattern.facet.prefecture)

          facets.push({
            mainPhoto,
            title: pattern.title,
            eventType: pattern.event_type,
            service: pattern.service,
            list
          })
        }
      })
    }

    return {
      total: state.total,
      facilities: state.facilities,
      features: state.features,
      facets,
      notices: state.notices,
      summaries: state.topSummaries
    }
  }
}

const mutations = {
  detail(state, detail) {
    state.detail = detail
  },
  nearbyList(state, nearbyList) {
    state.nearbyList = nearbyList
  },
  eventList(state, eventList) {
    state.eventList = eventList
  },
  stayList(state, stayList) {
    state.stayList = stayList
  },
  eatList(state, eatList) {
    state.eatList = eatList
  },
  summaries(state, summaries) {
    state.summaries = summaries
  },
  cityList(state, cityList) {
    state.cityList = cityList
  },
  total(state, total) {
    state.total = total
  },
  facilities(state, facilities) {
    state.facilities = facilities
  },
  features(state, features) {
    state.features = features
  },
  facets(state, facets) {
    state.facets = facets
  },
  notices(state, notices) {
    state.notices = notices
  },
  topSummaries(state, topSummaries) {
    state.topSummaries = topSummaries
  }
}

const actions = {
  async detail({ commit }, { id, params }) {
    const res = await this.$axios.get(
      methods.getApiBaseUrl() + '/pages/p/' + id,
      {
        params,
        validateStatus(status) {
          return status < 500
        }
      }
    )
    if (res.status && res.status === 404) {
      return
    }

    commit('detail', res.data.facility_detail)
    commit('nearbyList', res.data.nearby_facilities)
    commit('summaries', res.data.summaries)
    commit('cityList', res.data.cities)
    commit('stayList', res.data.nearby_stays.stays)
    commit('eatList', res.data.nearby_eats.eats)

    const list = []
    const nearbyList = res.data.nearby_events.events
    if (nearbyList.length >= 1) {
      for (let i = 0; i < nearbyList.length; i++) {
        list.push({
          name: nearbyList[i].title,
          description: nearbyList[i].description,
          office: nearbyList[i].office,
          image: nearbyList[i].image_url,
          url: nearbyList[i].event_url,
          start_date: nearbyList[i].start_date,
          end_date: nearbyList[i].end_date,
          place: nearbyList[i].place,
          place_url: nearbyList[i].place_url,
          address: nearbyList[i].address,
          lat: nearbyList[i].lat,
          lon: nearbyList[i].lon
        })
      }
    }

    commit('eventList', list)
  },

  // トップページ表示情報
  total({ commit }, total) {
    commit('total', total)
  },
  facilities({ commit }, facilities) {
    commit('facilities', facilities)
  },
  features({ commit }, features) {
    commit('features', features)
  },
  facets({ commit }, facets) {
    commit('facets', facets)
  },
  notices({ commit }, notices) {
    commit('notices', notices)
  },
  topSummaries({ commit }, summaries) {
    commit('topSummaries', summaries)
  },
  // トップページ表示情報を取得
  async index({ dispatch }) {
    const res = await this.$axios.get(
      methods.getApiBaseUrl() + '/pages/index',
      {
        validateStatus(status) {
          return status < 500
        }
      }
    )
    if (res.status && res.status === 404) {
      return
    }
    const data = res.data
    dispatch('total', data.total)
    dispatch('facilities', data.facilities)
    dispatch('features', data.features)
    dispatch('facets', data.facets)
    dispatch('notices', data.notices)
    dispatch('topSummaries', data.summaries)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
